

import {Component, Vue} from "vue-property-decorator";
import {AuthRequest} from "shared/api/routes/auth";
import {Api} from "shared/api";
import {AuthService} from "@/services/auth";
import {apiHandler} from "@/services/api-handler";

@Component({})
export default class Login extends Vue {
    authorization: AuthRequest = {email: "", password: ""};

    async mounted() {
        if (AuthService.user) {
            await this.$router.push("/");
        }
    }

    async sendAuthorization(event: Event) {
        event.preventDefault();
        const result = await apiHandler(() => Api.auth.Post(this.authorization));
        if (result.valid) {
            await AuthService.setToken(result.token);
            await this.$router.push("/");
        } else {
            alert(result.error);
        }
    }

    async forgotPassword() {
        if (this.authorization.email === "") {
            alert("Please fill out your email address.");
            return;
        }

        if (!confirm("This will send you an email to reset your password. Are you sure you want to continue?")) {
            return;
        }

        await apiHandler(() => Api.auth.reset.Post({email: this.authorization.email}));
        alert("Please check your email for the password reset request. If you do not receive an email, you may not have an account yet.");
    }
}

